// src/pages/AboutUs.js
import React from "react";
import InfoPageLayout from "./InfoPageLayout";

const AboutUs = () => {
  return (
    <InfoPageLayout
      title="About TimeWise"
      subtitle="Orchestrating time, so you can focus on life. A flagship product by Xenford."
    >
      <div className="space-y-8 text-gray-300 leading-relaxed">
        <section>
          <h2 className="text-2xl font-bold text-white mb-4">
            What is TimeWise?
          </h2>
          <p>
            TimeWise is more than just a calendar. It's a powerful, minimalist
            interface designed to bring harmony to the chaos of modern
            scheduling. We believe that managing your time shouldn't be a chore.
            Whether you're coordinating a multi-branch organization, scheduling
            appointments, or planning a personal event with friends, TimeWise
            provides the tools to do it with elegance and efficiency.
          </p>
          <p className="mt-4">
            Our platform unifies your professional and personal life, allowing
            you to see the complete picture of your commitments in one clean,
            intuitive dashboard.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-white mb-4">
            The Vision of Xenford
          </h2>
          <p>
            TimeWise is proudly developed and maintained by{" "}
            <strong>Xenford</strong>. At Xenford, our mission is to build
            digital products that simplify complexity. We focus on creating
            user-centric software that is not only powerful but also a joy to
            use.
          </p>
          <p className="mt-4">
            We are a team of thinkers, designers, and engineers dedicated to
            solving real-world problems through clean code and thoughtful
            design. TimeWise embodies our core philosophy: to give people back
            their most valuable asset—their time.
          </p>
        </section>
      </div>
    </InfoPageLayout>
  );
};

export default AboutUs;
